import { Fragment, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import PrivateRoute from './components/routing/PrivateRoute';
import ValidateSession from './components/routing/ValidateSession';
import NoMatch from './components/routing/NoMatch';

// Home
import Inicio from './views/home/Inicio';

// Login
import Login from './views/auth/Login';

// Register
import Register from './views/auth/Register';

// Dashboard
import Dashboard from './views/dashboard/Dashboard';

// Asesorias
import Asesorias from './views/asesorias/Asesorias';
import NuevaAsesoria from './views/asesorias/NuevaAsesoria';
import EditarAsesoria from './views/asesorias/EditarAsesoria';
import DetallesAsesoria from './views/asesorias/DetallesAsesoria';
import MiAsesor from './views/asesorias/MiAsesor';

// Membresia
import Membresia from './views/membresias/Membresia';

// Expediente
import Archivos from './views/expediente/Archivos';

// Legal
import AvisoPrivacidad from './views/legal/AvisoPrivacidad';
import TerminosCondiciones from './views/legal/TerminosCondiciones';
import Desuscripcion from './views/legal/Desuscripcion';

// Configuración
import PerfilPersonal from './views/configuracion/perfil_personal/Perfil';
import PerfilEmpresarial from './views/configuracion/perfil_empresarial/Perfil';
import MetodoPago from './views/configuracion/metodo_pago/MetodoPago';

// Redux
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

function App() {
	let token = false;
	
	if (localStorage.token) {
		token = true;
		setAuthToken(localStorage.token);
	}

	useEffect(() => {
		store.dispatch(loadUser());
	}, []);

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Fragment>
					<Layout>
						<Alert></Alert>

						<Routes>
							{/* Home */}
							<Route exact path="/" element={<ValidateSession isToken={token}><Inicio /></ValidateSession>}/>

							{/* Login */}
							<Route exact path="/login" element={<ValidateSession isToken={token}><Login /></ValidateSession>}/>

							{/* Register */}
							<Route exact path="/register" element={<ValidateSession isToken={token}><Register /></ValidateSession>}/>

							{/* Dashboard */}
							<Route path="/dashboard" element={<PrivateRoute routePermission=''><Dashboard /></PrivateRoute>}/>

							{/* Asesorias */}
							<Route path="/asesorias" element={<PrivateRoute routePermission='asesorias.ver'><Asesorias /></PrivateRoute>}/>
							<Route path="/asesorias/nueva" element={<PrivateRoute routePermission='asesorias.agregar'><NuevaAsesoria /></PrivateRoute>}/>
							<Route path="/asesorias/editar/:id" element={<PrivateRoute routePermission='asesorias.editar'><EditarAsesoria /></PrivateRoute>}/>
							<Route path="/asesorias/detalles/:id" element={<PrivateRoute routePermission='asesorias.detalles'><DetallesAsesoria /></PrivateRoute>}/>
							<Route path="/mi-asesor" element={<PrivateRoute routePermission='asesor.ver'><MiAsesor /></PrivateRoute>}/>

							{/* Membresias */}
							<Route path="/membresia" element={<PrivateRoute routePermission='membresia.ver'><Membresia /></PrivateRoute>}/>

							{/* Expediente */}
							<Route path="/expediente" element={<PrivateRoute routePermission='expediente.ver'><Archivos /></PrivateRoute>}/>

							{/* Configuración */}
							<Route path="/configuracion/perfil_personal" element={<PrivateRoute routePermission='configuracion.perfil_personal.ver'><PerfilPersonal /></PrivateRoute>}/>
							<Route path="/configuracion/perfil_empresarial" element={<PrivateRoute routePermission='configuracion.perfil_empresarial.ver'><PerfilEmpresarial /></PrivateRoute>}/>
							<Route path="/configuracion/metodo_pago" element={<PrivateRoute routePermission='configuracion.metodo_pago.ver'><MetodoPago /></PrivateRoute>}/>
							
							{/* Legal */}
							<Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />}/>
							<Route path="/terminos-y-condiciones" element={<TerminosCondiciones />}/>
							<Route path="/desuscripcion_cliente/:id/:firma" element={<Desuscripcion />}/>

							{/* Cuando no matchea con nada*/}
							<Route path="*" element={<NoMatch />}/>
						</Routes>
					</Layout>
				</Fragment>
			</BrowserRouter>
		</Provider>
	);
}

export default App;